import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { fipRoute } from '../route';

export const fipHomeRoute = createRoute({
	path: '/home',
	getParentRoute: () => fipRoute,
	component: lazyRouteComponent(() => import('./FipHomePage'), 'FipHomePage'),
});
